import {
    GET_GOAL_BY_ID_SUCCESS,
    GET_GOAL_CLINICAL_DATA_SUCCESS,
    GET_GOAL_CLINICAL_DEFAULT_VALUES,
    GET_GOAL_CLINICAL_DEFAULT_VALUES_SUCCESS,
    GET_GOAL_GRAPH_SUCCESS,
    GET_GOAL_SESSIONS_SUCCESS,
    GET_GOAL_TARGET_CLINICAL_DATA_SUCCESS,
    GET_GOAL_TRIAL_DATA_SUCCESS,
    GET_GOALS_FOR_SESSION_SUCCESS,
    GET_GOALS_SUCCESS,
    GET_SECTION_TYPES_SUCCESS,
    GET_SIMPLE_GOALS_SUCCESS,
    GET_TARGET_CHART_DATA_SUCCESS,
    REORDER_OPTION,
    REORDER_TARGET,
    REORDER_SECTION_DESCRIPTION_BLOCKS,
} from './goal.types';

const initialState = {
    goalList: [],
    simpleGoals: [],
    goalsForSession: [],
    goalById: null,
    sectionTypes: [],
    targetChartData: null,
    goalSessions: [],
    goalGraph: null,

    goalTrialData: [],
    goalClinicalData: {},
    goalTargetClinicalData: {},
    goalDefaultValues: [],
};

export const goalReducer = (state = initialState, action) => {
    switch (action.type) {
        /** Goals */
        case GET_GOALS_SUCCESS:
            return {
                ...state,
                goalList: action.payload,
            };

        case GET_GOALS_FOR_SESSION_SUCCESS:
            return {
                ...state,
                goalsForSession: action.payload,
            };

        case GET_SIMPLE_GOALS_SUCCESS:
            return {
                ...state,
                simpleGoals: action.payload,
            };

        case GET_GOAL_BY_ID_SUCCESS:
            return {
                ...state,
                goalById: action.payload,
            };

        case GET_SECTION_TYPES_SUCCESS:
            return {
                ...state,
                sectionTypes: action.payload,
            };

        case GET_GOAL_SESSIONS_SUCCESS:
            return {
                ...state,
                goalSessions: action.payload,
            };

        case GET_GOAL_GRAPH_SUCCESS:
            return {
                ...state,
                goalGraph: action.payload,
            };

        case GET_GOAL_TRIAL_DATA_SUCCESS:
            return {
                ...state,
                goalTrialData: action.payload,
            };
        /** End */

        /** Targets */
        case REORDER_TARGET:
            return {
                ...state,
                goalById: action?.payload?.goal,
            };

        /** Optimistic — the saga re-fetches the goal on failure to roll back */
        case REORDER_SECTION_DESCRIPTION_BLOCKS:
            return {
                ...state,
                goalById: action?.payload?.goal,
            };

        case GET_TARGET_CHART_DATA_SUCCESS:
            return {
                ...state,
                targetChartData: action?.payload,
            };

        /** End */

        /** Options */
        case REORDER_OPTION:
            return {
                ...state,
                goalById: action?.payload?.goal,
            };

        /** End */

        /** Goal Clinical Data */

        case GET_GOAL_CLINICAL_DATA_SUCCESS:
            return {
                ...state,
                goalClinicalData: action.payload,
            };

        case GET_GOAL_TARGET_CLINICAL_DATA_SUCCESS:
            return {
                ...state,
                goalTargetClinicalData: action.payload,
            };

        case GET_GOAL_CLINICAL_DEFAULT_VALUES_SUCCESS:
            return {
                ...state,
                goalDefaultValues: action.payload,
            };

        /** End */

        default:
            return state;
    }
};
